<div class="my-2">
    <span class="text-primary cursor-pointer" (click)="redirect()">{{ origin }} </span>
    <span class="text-gray-600 px-2"> / </span>
    <span class="text-gray-400 cursor-pointer"> {{ destin }}</span>
</div>
